export * from '@pleo-io/telescope-avatar';
export * from '@pleo-io/telescope-button';
export * from '@pleo-io/telescope-checkbox';
export * from '@pleo-io/telescope-focus-ring';
export * from '@pleo-io/telescope-global-style';
export { Inline, Stack } from '@pleo-io/telescope-layout';
export * from '@pleo-io/telescope-list';
export * from '@pleo-io/telescope-modal';
export * from '@pleo-io/telescope-progress-bar';
export { Text } from '@pleo-io/telescope-text';
export * from '@pleo-io/telescope-theme';
import * as border from '@pleo-io/telescope-tokens';
import * as color from '@pleo-io/telescope-tokens/dist/color';
export { color };
import * as duration from '@pleo-io/telescope-tokens/dist/duration';
export { duration };
import * as fontSize from '@pleo-io/telescope-tokens/dist/font-size';
export { fontSize };
import * as fontWeight from '@pleo-io/telescope-tokens/dist/font-weight';
export { fontWeight };
import * as lineHeight from '@pleo-io/telescope-tokens/dist/line-height';
export { lineHeight };
import * as opacity from '@pleo-io/telescope-tokens/dist/opacity';
export { opacity };
import * as radius from '@pleo-io/telescope-tokens/dist/radius';
export { radius };
import * as rgba from '@pleo-io/telescope-tokens/dist/rgba';
import * as shadow from '@pleo-io/telescope-tokens/dist/shadow';
export { shadow };
import * as spacing from '@pleo-io/telescope-tokens/dist/spacing';
export { spacing };
import * as transition from '@pleo-io/telescope-tokens/dist/transition';
export { transition };
import * as zIndex from '@pleo-io/telescope-tokens/dist/z-index';
export { zIndex };
export * from '@pleo-io/telescope-input';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var tokens = /*#__PURE__*/_extends({}, border, color, fontSize, fontWeight, lineHeight, opacity, radius, rgba, shadow, spacing, transition, zIndex);

export { tokens };